import type { SvgIcon } from '../../components/_primitives/icon/types'
import type { ColorStateKey } from '../../theme-provider/types'

export type AlertStatus = 'info' | 'warning' | 'success' | 'error'

export const STATUSES: Record<
  AlertStatus,
  { icon: SvgIcon; color: Omit<ColorStateKey, 'muted'> | 'neutral.darker' }
> = {
  info: { icon: 'info', color: 'neutral.darker' },
  warning: { icon: 'mui-warning', color: 'warning' },
  success: { icon: 'select', color: 'success' },
  error: { icon: 'exclamation', color: 'danger' }
}
